
import React from "react"
import autobind from "class-autobind"
import * as api from "../../api"

interface IProps {
    htmlUrl: string,
}

interface IState {
    loadedHtml: string,
    loading: boolean,
}

export default class HtmlLoader extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            loadedHtml: null,
            loading: true
        }
        autobind(this)
    }

    componentDidMount() {
        if(this.state.loading){
            api.loadHtml(this.props.htmlUrl).then((res)=>{
                this.setState({loadedHtml: res.data, loading: false})
            })   
        } 
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <span>
                {this.state.loading && 
                    <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                        Loading...
                    </div>
                }
                {!this.state.loading && 
                    <div dangerouslySetInnerHTML={{__html: this.state.loadedHtml}} />
                }
            </span>
        )
    }
}